import { Typography } from '@mui/material';

export const VerdictInputCancellationAskedText = () => {
  return (
    <Typography>Seul l'avis d'annulation est disponible car la demande est en attente d'avis d'annulation.</Typography>
  );
};
